import React from "react"
import styled from "styled-components"

import { Color, Spacing, Typography } from "@persona-id/design-tokens"
import Spacer from "@persona-id/design-system/components/Spacer"
import { ContentfulCategory } from "../models/contentful"
import NavigationLeftAcademy from "./NavigationLeftAcademy"
import NavigationLeftArticles from "./NavigationLeftArticles"
import NavigationLeftCommunity from "./NavigationLeftCommunity"
import NavigationLeftHelp from "./NavigationLeftHelp"
import Button from "@persona-id/design-system/components/Button"

const NavigationLeftMobile = ({
  currentCategory,
  closeMobileNav,
}: {
  currentCategory: ContentfulCategory
  closeMobileNav: () => void
}) => {
  return (
    <NavigationLeftMobileWrapper>
      <NavigationLeftMobileHeading>Articles</NavigationLeftMobileHeading>
      <NavigationLeftArticles
        currentCategory={currentCategory}
        onNavLinkClick={() => closeMobileNav()}
      />
      <Spacer height={2} />
      <NavigationLeftMobileHeading>Community</NavigationLeftMobileHeading>
      <NavigationLeftCommunity onNavLinkClick={() => closeMobileNav()} />
      <Spacer height={2} />
      {!(process.env.IS_ACADEMY_DISABLED === "true") && (
        <>
          <NavigationLeftMobileHeading>Academy</NavigationLeftMobileHeading>
          <NavigationLeftAcademy onNavLinkClick={() => closeMobileNav()} />
          <Spacer height={2} />
        </>
      )}
      <NavigationLeftMobileHeading>Get help now</NavigationLeftMobileHeading>
      <NavigationLeftHelp />
      <Spacer height={2} />
      <a
        href={`${process.env.PERSONA_HOSTNAME}/dashboard`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          id="navigation-mobile__dashboard"
          aria-label="navigation-mobile__dashboard"
          variant="basic"
          size="md"
        >
          Go to Dashboard
        </Button>
      </a>
    </NavigationLeftMobileWrapper>
  )
}

const NavigationLeftMobileWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 56px;
  left: 0px;
  padding: ${Spacing[3]};
  background-color: ${Color.PrimaryWhite};
  border-top: 1px solid ${Color.BorderDivider};
  border-bottom: 1px solid ${Color.BorderDivider};

  a {
    color: ${Color.TextPrimary};
    text-decoration: none;
  }
`

const NavigationLeftMobileHeading = styled("h2")`
  ${Typography.HeadingSmall};
  margin: 0px;
  margin-bottom: ${Spacing[1]};
`

export default NavigationLeftMobile
